import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import * as playerActions from "../../actions/playerActions";
import PlayerPaths from "../../constants/paths/playerPaths";
import { markdownToHtml } from "../../utils/markupUtils";
import MediaAttachments from "./MediaAttachments";
import _ from "lodash";
import PropTypes from "baobab-react/prop-types";

class Comments extends PureComponent {
	constructor(props, context) {
		super(props);
		const { listIndex, sectionIndex, itemIndex } = this.props;
		const selectedItem = context.tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));

		let hasComments = selectedItem.comments !== null && typeof selectedItem.comments !== "undefined" && selectedItem.comments !== "";
		let hasNotes = selectedItem.notes !== null && typeof selectedItem.notes !== "undefined" && selectedItem.notes !== "";
		//let hasSketchPadImage = props.sketchPadImage != null && props.sketchPadImage != "undefined" && props.sketchPadImage != "";
		let hasMediaAttachments = selectedItem.mediaAttachments !== null && typeof selectedItem.mediaAttachments !== "undefined" && _.get(selectedItem, "mediaAttachments.length") > 0;

		let tabIndex = 0;


		if (hasComments) {
			tabIndex = 0;
		} else if (!hasComments && hasNotes) {
			tabIndex = 1;
		} else if (!hasComments && hasMediaAttachments) {
			tabIndex = 2;
		} //else if (!hasComments && hasSketchPadImage) {
		//	tabIndex = 3;
		//}

		this.handleSelectTab(tabIndex);

		this.state = {
			tabIndex: tabIndex,
			notes: selectedItem.notes ? selectedItem.notes : "",
			canGoBack: false,
			canGoForward: false,
			canReload: true,
			session: 0,
			contentWidth: 0,
			contentHeight: 0,
			toggleScroll: false,
		};
	}

	handleSelectTab(tabIndex) {
		this.props.dispatch(
			playerActions.selectCommentsTab,
			tabIndex
		)
	}

	componentWillUnmount() {
		if ((this.props.listIndex || this.props.listIndex === 0) && (this.props.sectionIndex || this.props.sectionIndex === 0) && (this.props.itemIndex || this.props.itemIndex === 0)) {
			playerActions.setNotes(this.context.tree, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex, this.state.notes);
		}
	}


	render() {
		// let self = this;
		const { listIndex, sectionIndex, itemIndex } = this.props;

		const selectedItem = this.context.tree.get(PlayerPaths.ACTIVITY_ITEM(listIndex, sectionIndex, itemIndex));
		//let theme = themes[(this.props.nightMode) ? "nightMode" : "default"];

		//let backgroundColor = theme.modal.content.bgColor;

		//const sketchPadCanvasPenColor = theme.comments.sketchPad.canvas.penColor;
		//const sketchPadCanvasBackgroundColor = theme.comments.sketchPad.canvas.bgColor;
		//const sketchPadContainerBackgroundColor = theme.comments.sketchPad.container.bgColor;


		let htmlComments;
		if (selectedItem.comments && selectedItem.comments !== "") {
			htmlComments = selectedItem.comments;
		} else {
			htmlComments = "There are no comments.";
		}

		//let html = "<html id=\"myContent\" style=\"font-family: Arial; background-color: " + backgroundColor + "\"><head><meta name=\"viewport\" content=\"width=device-width\"></head><body>" + htmlComments + "</body></html>";

		/*
		let showGoBack;
		showGoBack =
			<TouchableOpacity disabled={!this.state.canGoBack} onPress={(e) => { this.myWebView.goBack(); }}>
				<Text style={{ marginLeft: 5, padding: 5, fontWeight: "bold", color: this.state.canGoBack ? "blue" : "gray" }}>
					<Icon name={"arrow-circle-left"} size={20} />
				</Text>
			</TouchableOpacity>;

		let showGoForward;
		showGoForward =
			<TouchableOpacity disabled={!this.state.canGoForward} onPress={(e) => { this.myWebView.goForward(); }}>
				<Text style={{ marginLeft: 5, padding: 5, fontWeight: "bold", color: this.state.canGoForward ? "blue" : "gray" }}>
					<Icon name={"arrow-circle-right"} size={20} />
				</Text>
			</TouchableOpacity>;

		let showReload;
		showReload =
			<TouchableOpacity disabled={!this.state.canReload} onPress={(e) => { this.setState({ session: this.state.session + 1 }); this.forceUpdate(); }}>
				<Text style={{ right: 5, textAlign: "right", padding: 5, fontWeight: "bold", color: this.state.canReload ? "blue" : "gray" }}>
					<Icon name={"refresh"} size={20} />
				</Text>
			</TouchableOpacity>;
		

		let webView =
			<View style={{ flex: 1 }}>
				<WebView key={this.state.session} tabLabel="Comments"
					style={{ backgroundColor: backgroundColor }}
					ref={(ref) => { this.myWebView = ref; }}
					html={html}
					javaScriptEnabled={true}
					onNavigationStateChange={(event) => {
						this.setState({
							//canReload: event.url === "about:blank"?false:true,
							canGoBack: event.canGoBack,
							canGoForward: event.canGoForward
						});
					}}
				>
				</WebView>
				<View style={{ flexDirection: "row", justifyContent: "space-between" }}>
					<View style={{ flexDirection: "row" }}>
						{showGoBack}
						{showGoForward}
					</View>
					{showReload}
				</View>
			</View>;
		*/

		let commentsView = <div style={{ backgroundColor: "white", boxSizing: "border-box", padding: "8px", flex: 1, overflowY: "auto",maxHeight:'100%' }}>
			<div style={{ width: "100%", height: "100%" }} dangerouslySetInnerHTML={{ __html: htmlComments }}>
			</div>
		</div>;


		let textInput =
			<textarea
				className="form-control"
				type="text"
				value={this.state.notes}
				onChange={(e) => { playerActions.setNotes(this.context.tree, this.props.listIndex, this.props.sectionIndex, this.props.itemIndex, e.target.value, false); this.setState({ notes: e.target.value }); }}
				placeholder={"Enter notes here..."}
				autoCapitalize={"sentences"}
				style={{ height: "100%", border: "none", resize: "none", outline: "none" }} />;

		//let newMarkdownStyles = _.cloneDeep(markdownStyles);
		//newMarkdownStyles.paragraph.marginBottom = 10;

		let notesPreview = <div dangerouslySetInnerHTML={markdownToHtml(this.state.notes)} />;

		let notes =
			<div style={{ flex: 1, backgroundColor: "white", display: "flex", flexDirection: "column" }}>
				<div style={{ flex: 2, height: "100%" }}>
					{textInput}
				</div>
				<div style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 10, fontSize: 10, color: "gray", flex: 0 }}>Preview</div>
				<div style={{ paddingLeft: 10, paddingRight: 10, paddingTop: 5, paddingBottom: 5, flex: 1 }}>
					{notesPreview}
				</div>
			</div>;


		// TODO: JJB Don't like doing this here - think about alternative
		//const selectedListIndex = this.context.tree.get(["activity", "selectedListIndex"]);
		//const selectedSectionIndex = this.context.tree.get(["activity", "selected", "sectionIndex"]);
		//const selectedItemIndex = this.context.tree.get(["activity", "selected", "itemIndex"]);
		//const selectedItem = this.context.tree.get(["activity", "children", selectedListIndex, "children", selectedSectionIndex, "children", selectedItemIndex]);

		//let sketchPadSimple =
		//	<Text style={{ margin: 10, color: "red", fontStyle: "italic", fontWeight: "bold" }}>Upgrade to Pro plan to display this item type.</Text>;	


		let currentView;
		if (this.props.tabIndex === 0) {
			currentView = commentsView;
		} else if (this.props.tabIndex === 1) {
			currentView = notes;
		} else if (this.props.tabIndex === 2) {
			//{ listIndex: this.props.listIndex, sectionIndex: this.props.sectionIndex, itemIndex: this.props.itemIndex }
			//const { listIndex, sectionIndex, itemIndex } = this.props;
			let mediaAttachments = <MediaAttachments listIndex={listIndex} sectionIndex={sectionIndex} itemIndex={itemIndex} />;
			currentView = mediaAttachments;
		}

		let media;
		if (this.props.persistenceType.toLowerCase() !== "default") {
			media = <div className="player-comments-button" onClick={() => { this.handleSelectTab(2); }} style={{ color: this.props.tabIndex === 2 ? "blue" : "gray" }}>
				Media
			</div>;
		}

		return (
			<div ref={(c) => this._mainView = c} style={{ flex: 1, backgroundColor: "#F9A200", width: "100%", display: "flex", flexDirection: "column" }}>
				<div ref={(c) => this._tabs = c} style={{ display: "flex", backgroundColor: "#F9A200", flexDirection: "row" }}>
					<div className="player-comments-button" onClick={() => { this.handleSelectTab(0); }} style={{ color: this.props.tabIndex === 0 ? "blue" : "gray" }}>
						Comments
				</div>
					<div className="player-comments-button" onClick={() => { this.handleSelectTab(1); }} style={{ color: this.props.tabIndex === 1 ? "blue" : "gray" }}>
						Notes
				</div>
					{media}
				</div>
				{currentView}
			</div>
		);
	}
}

Comments.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	tabIndex: ["player", "showCommentsIdx"],
	persistenceType: ["appState", "targetConfig", "type"]
}, Comments);